export const getWorksheetsUrl = (locationId: string, agentId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/worksheets`;

export const getWorksheetUrl = (locationId: string, agentId: string, worksheetId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/worksheets/${worksheetId}`;

export const getColumnsUrl = (locationId: string, agentId: string, worksheetId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/worksheets/${worksheetId}/columns`;

export const getDeleteColumnUrl = (locationId: string, agentId: string, worksheetId: string, columnId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/worksheets/${worksheetId}/columns/${columnId}`;

export const getDeleteRowUrl = (locationId: string, agentId: string, worksheetId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/worksheets/${worksheetId}/rows`;

export const getAddColumnUrl = (locationId: string, agentId: string, worksheetId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/worksheets/${worksheetId}/columns`;

export const getRowsUrl = (locationId: string, agentId: string, worksheetId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/worksheets/${worksheetId}/rows`;

export const getAddCRowUrl = (locationId: string, agentId: string, worksheetId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/worksheets/${worksheetId}/rows`;

export const UpdateCellUrl = (locationId: string, agentId: string, worksheetId: string, columnId: any, rowId: any) =>
  `/business/locations/${locationId}/agents/${agentId}/worksheets/${worksheetId}/cells?row_id=${rowId}&column_id=${columnId}`;

export const UpdateColumnUrl = (locationId: string, agentId: string, worksheetId: string, columnId: any) =>
  `/business/locations/${locationId}/agents/${agentId}/worksheets/${worksheetId}/columns/${columnId}`;

export const UpdateRowUrl = (locationId: string, agentId: string, worksheetId: string, rowId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/worksheets/${worksheetId}/rows/${rowId}`;

export const workflowExecuteUrl = (locationId: string, agentId: string, worksheetId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/worksheets/${worksheetId}/workflows/execute?`;

export const importCsvUrl = (locationId: string, agentId: string, worksheetId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/worksheets/${worksheetId}/upload_file`;

export const appendCsvUrl = (locationId: string, agentId: string, worksheetId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/worksheets/${worksheetId}/append_from_csv`;

export const getWorkflowUrl = (locationId: string) => `/business/locations/${locationId}/workflows`;
